/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_RankingInputs */

const en_us2_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking`)
};

const pt_br2_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking`)
};

const es_419_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking`)
};

const pt_pt2_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação`)
};

const fr_fr2_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement`)
};

const de_de2_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangliste`)
};

const it_it2_clubs_field_ranking = /** @type {(inputs: Clubs_Field_RankingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifica`)
};

/**
* | output |
* | --- |
* | "Ranking" |
*
* @param {Clubs_Field_RankingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_ranking = /** @type {((inputs?: Clubs_Field_RankingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_RankingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_ranking(inputs)
	if (locale === "es-419") return es_419_clubs_field_ranking(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_ranking(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_ranking(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_ranking(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_ranking(inputs)
	return en_us2_clubs_field_ranking(inputs)
});
export { clubs_field_ranking as "clubs.field_ranking" }